module.exports = __webpack_public_path__ + "img/22ne.bd29794b.svg";